module.exports = __webpack_public_path__ + "static/media/mail.acade3d2.svg";